import type { FaireProductEntity } from "../../entity_types/product";

export const p_wffdgdysuk: FaireProductEntity = {
  token: "p_wffdgdysuk",
  type: "product",
  name: "Balm Baby - Eczema Calmer All Natural Eczema Relief",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/4103b239ea6db086a3f5c162c895178213f83c2ff66c837c09c8e956ce34a00a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed2148042ade61bb9e205ae0a1abc3bb941bc514f2ab509854df33c8a1771c2b.jpeg",
    "https://cdn.faire.com/fastly/20ad9c990c9a2c7d37a73d2dab98b1bb05902b5295c8fb7d011865a3e2121fb1.jpeg",
    "https://cdn.faire.com/fastly/e0076059aadd0c252e8465213aa053033033ab6e9040e794fa1c8e4bcbcdd9b0.jpeg",
  ],
  priceDollars: 7.6,
  description:
    'We’ve formulated a special herb infused  balm to help aid in relieving and soothing itchy, dry eczema. While we believe that eczema comes from within and have seen it subside from diet, it’s nice to have some relief from it while it’s bugging you! \nUSE On inflamed, dry, itchy, owie eczema.  For use all over the body.  Great for those super sensitive places that eczema attacks, like the face and hands. \n\n* Soothing. Healing. Moisturizing\n* 2 oz / 60 ml Glass Jar with metal lid\n* Cloth diaper safe (if needed in that area)\n* Quality, Effective product FREE of No-Nos!\n* Vegan, Non-GMO, Gluten & Nut * Free, Cruelty-FREE\n* Multi Purpose 1st Aid "Everything" Skin! Tried and Tested TRUE on 1000\'s of Families!\n\nIngredients: Organic extra virgin olive oil, organic raw shea butter, organic raw cocoa butter, organic chickweed, organic calendula, organic chamomile, yellow dock root, candelilla wax, tocopherol (vitamin e)  pure lavender essential oil (if scent is chosen)\n',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:01.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
